import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import VueI18n from 'vue-i18n'
import { messages } from '@src/i18n/index.js'
import SvgIcon from 'vue-svgicon'
import '@src/components/svgs'
import { getSavedState } from '@src/utils/localStorage'
import VueSwal from 'vue-swal'
import VueDateFns from 'vue-date-fns'
import vSelect from 'vue-select'
import VueTheMask from 'vue-the-mask'
import { VueMasonryPlugin } from 'vue-masonry'
import VueTagManager from 'vue-tag-manager'
import router from '@src/router'

Vue.use(VueMasonryPlugin)
Vue.use(BootstrapVue)
Vue.use(VueI18n)
Vue.use(SvgIcon, {
    tagName: 'svgicon',
})
Vue.use(VueTagManager, {
    gtmId: 'GTM-58NKHGB',
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    vueRouter: router,
})
Vue.use(VueSwal)
Vue.use(VueDateFns)
export const i18n = new VueI18n({
    locale: getSavedState('user.currentLanguage'),
    messages: messages,
})

Vue.component('v-select', vSelect)
Vue.use(VueTheMask)
